<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import {
		storeElementID,
		storeData,
		storeSelectedIcon,
		storeAnimate,
		storeShowGallery,
		storeSelectedTool,
	} from '../../library/scripts/Store.svelte'
	import { get_initial_values, get_element_tags, string_to_fontsize } from '../builderUtils'
	import ColorSelector from '../ColorSelector.svelte'
	import SelectValues from '../SelectValues.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let width

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	const iconHover = globals.colorError
	let iconTitleWeight = globals.colorDark
	let iconTitleStyle = globals.colorDark
	let iconTitleDeco = globals.colorDark
	let iconTextWeight = globals.colorDark
	let iconTextStyle = globals.colorDark
	let subTool = globals.subTool
	let mainTool = globals.mainTool
	let subToolHover = globals.subToolHover
	let mainToolHover = globals.mainToolHover
	const fontFamily = globals.fontFamily
	const fontSize = globals.fontSize

	let elementID
	let config
	let blocks
	let blockID

	//show hide tool
	let generalTool1 = false
	let generalTool2 = false
	let showTool0 = false
	let showTool1 = false
	let showTool2 = false
	let showTool3 = false
	let showTool4 = false
	let showTool5 = false
	let showTool6 = false
	let showTool7 = false
	let showTool8 = false
	let showTool9 = false
	let showTool10 = false
	let showTool11 = false

	//the selectedIcon from store
	let selectedStoreIcon

	//change layout order
	let shaderChangeOrder = false

	//the values to send to sizeSelectors
	let selectedBorderWidth
	let selectedTitleBorderWidth
	let selectedTextBorderWidth

	//css selections
	let selectedBorderColor = 'hsla(0,0%,100%,1)'
	let selectedBackgroundColor
	let selectedBgOpac
	let selectedTitleBorderColor = 'hsla(0,0%,100%,1)'
	let selectedTextBorderColor = 'hsla(0,0%,100%,1'
	let selectedColor
	let selectedSliderWidth
	let selectedSliderHeight
	let selectedMTitleBGColor
	let selectedMTitleBGOpac
	let selectedTBLwidth
	let selectedTBTwidth
	let selectedTBRwidth
	let selectedTBBwidth
	let selectedTTradius
	let selectedTBradius
	let selectedTitleFont
	let selectedTitleFontColor
	let selectedTitleSize
	let selectedTitleFontOpac
	let selectedMBLwidth
	let selectedMBTwidth
	let selectedMBRwidth
	let selectedMBBwidth
	let selectedTitleShadowColor
	let selectedTitleShadowOpac
	let selectedTitleOffsetX
	let selectedTitleOffsetY
	let selectedTitleBlur
	let selectedMBTradius
	let selectedMBBradius
	let selectedMSC
	let selectedMSX
	let selectedMSY
	let selectedMSB
	let selectedMTitleWidth
	let selectedMTitleHeight
	let selectedMTitleLeft
	let selectedMTitleTop
	let selectedTXTBLwidth
	let selectedTXTBTwidth
	let selectedTXTBRwidth
	let selectedTXTBBwidth
	let selectedMTextBGColor
	let selectedMTextBGOpac
	let selectedMTextWidth
	let selectedMTextHeight
	let selectedMTextLeft
	let selectedMTextTop
	let selectedTextBLwidth
	let selectedTextBTwidth
	let selectedTextBRwidth
	let selectedTextBBwidth
	let selectedTextTradius
	let selectedTextBradius
	let selectedTextShadowColor
	let selectedTextShadowOpac
	let selectedTextOffsetX
	let selectedTextOffsetY
	let selectedTextBlur
	let selectedTextFontColor
	let selectedTextFontOpac
	let selectedTextFont
	let selectedTextSize
	let selectedMC
	let selectedMChover

	//icon selected
	let selectedIcon
	let selectedIicon

	//set icons
	let icon1 = false
	let icon2 = false
	let icon3 = false
	let icon4 = false
	let icon5 = false
	let icon6 = false
	let icon7 = false
	let icon8 = false
	let icon9 = false

	let icon1Color = iconColor
	let icon2Color = iconColor
	let icon3Color = iconColor
	let icon4Color = iconColor
	let icon5Color = iconColor
	let icon6Color = iconColor
	let icon7Color = iconColor
	let icon8Color = iconColor
	let icon9Color = iconColor

	//stative ID for getElementById in SelectValues
	let idSelect1 = 'selFont'
	let idSelect2 = 'selSize'
	const idColor1 = '100'
	const idColor2 = '102'
	const idColor3 = '103'
	const idColor4 = '104'
	const idColor5 = '105'
	const idColor6 = '106'
	const idColor7 = '107'
	const idColor8 = '108'
	const idSliderWidth = '14'
	const idSliderHeight = '12'
	const idBorderWidth = '6'
	const idTitleHeight = '26'
	const idTitleBW = '29'
	const idTextHeight = '45'
	const idTextBW = '48'

	//show border tools
	let iconSelected = false

	//slider inset (text window)
	let iconIselected = false

	//animation
	let autoplay
	const stoAnimate = storeAnimate.subscribe((value) => {
		autoplay = value
	})

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	//set the initial css values from config.json
	$: if (elementID === 'gallery') {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		const values = get_initial_values(elementID, blocks, tags)
		selectedSliderWidth = values[22][69]
		selectedSliderHeight = values[22][70]
		selectedMBLwidth = values[22][71]
		selectedMBTwidth = values[22][72]
		selectedMBRwidth = values[22][73]
		selectedMBBwidth = values[22][74]
		selectedMBTradius = values[22][75]
		selectedMBBradius = values[22][76]
		selectedMSC = values[22][77]
		selectedMSX = values[22][78]
		selectedMSY = values[22][79]
		selectedMSB = values[22][80]
		selectedMTitleBGColor = values[22][81]
		selectedMTitleBGOpac = values[22][82]
		selectedMTitleWidth = values[22][83]
		selectedMTitleHeight = values[22][84]
		selectedMTitleLeft = values[22][85]
		selectedMTitleTop = values[22][86]
		selectedTBLwidth = values[22][87]
		selectedTBTwidth = values[22][88]
		selectedTBRwidth = values[22][89]
		selectedTBBwidth = values[22][90]
		selectedTTradius = values[22][91]
		selectedTBradius = values[22][92]
		selectedTitleShadowColor = values[22][93]
		selectedTitleShadowOpac = values[22][94]
		selectedTitleOffsetX = values[22][95]
		selectedTitleOffsetY = values[22][96]
		selectedTitleBlur = values[22][97]
		selectedTitleFontColor = values[22][98]
		selectedTitleFontOpac = values[22][99]
		selectedTitleFont = values[22][100]
		selectedTitleSize = values[22][101]
		set_fontstyle_initial_value('title', values[22][102], values[22][103], values[22][104])
		selectedMTextBGColor = values[22][105]
		selectedMTextBGOpac = values[22][106]
		selectedMTextWidth = values[22][107]
		selectedMTextHeight = values[22][108]
		selectedMTextLeft = values[22][109]
		selectedMTextTop = values[22][110]
		selectedTextBLwidth = values[22][111]
		selectedTextBTwidth = values[22][112]
		selectedTextBRwidth = values[22][113]
		selectedTextBBwidth = values[22][114]
		selectedTextTradius = values[22][115]
		selectedTextBradius = values[22][116]
		selectedTextShadowColor = values[22][117]
		selectedTextShadowOpac = values[22][118]
		selectedTextOffsetX = values[22][119]
		selectedTextOffsetY = values[22][120]
		selectedTextBlur = values[22][121]
		selectedTextFontColor = values[22][122]
		selectedTextFontOpac = values[22][123]
		selectedTextFont = values[22][124]
		selectedTextSize = values[22][125]
		set_fontstyle_initial_value('text', values[22][126], values[22][127])
		selectedBackgroundColor = values[22][128]
		selectedBgOpac = values[22][129]
		selectedMC = values[22][130]
		selectedMChover = values[22][131]

		if (selectedMBLwidth > 0) {
			icon1 = true
			set_icon_color('left', 1)
		}
		if (selectedMBTwidth > 0) {
			icon2 = true
			set_icon_color('top', 2)
		}

		if (selectedMBRwidth > 0) {
			icon3 = true
			set_icon_color('right', 3)
		}

		if (selectedMBBwidth > 0) {
			icon4 = true
			set_icon_color('bottom', 4)
		}

		if (selectedMBLwidth > 0 && selectedMBTwidth > 0 && selectedMBRwidth > 0 && selectedMBBwidth > 0) {
			icon1 = true
			icon2 = true
			icon3 = true
			icon4 = true
			icon5 = true
			set_icon_color('all', 5)
		}

		if (selectedTBTwidth > 0) {
			icon6 = true
			set_icon_color('top', 6)
		}

		if (selectedTBBwidth > 0) {
			icon7 = true
			set_icon_color('bottom', 7)
		}

		if (selectedTextBTwidth > 0) {
			icon8 = true
			set_icon_color('top', 8)
		}

		if (selectedTextBBwidth > 0) {
			icon9 = true
			set_icon_color('bottom', 9)
		}
	}

	$: if (!icon1 && !icon2 && !icon3 && !icon4 && !icon5) iconSelected = false
	$: if (!icon6 && !icon7) iconIselected = false
	$: if (!icon8 && !icon9) iconIselected = false

	$: if (selectedStoreIcon === 'icon1') selectedBorderWidth = selectedMBLwidth
	$: if (selectedStoreIcon === 'icon2') selectedBorderWidth = selectedMBTwidth
	$: if (selectedStoreIcon === 'icon3') selectedBorderWidth = selectedMBRwidth
	$: if (selectedStoreIcon === 'icon4') selectedBorderWidth = selectedMBBwidth
	$: if (selectedStoreIcon === 'icon5') selectedBorderWidth = selectedMBLwidth
	$: if (selectedStoreIcon === 'icon6') selectedTitleBorderWidth = selectedTBTwidth
	$: if (selectedStoreIcon === 'icon7') selectedTitleBorderWidth = selectedTBBwidth
	$: if (selectedStoreIcon === 'icon8') selectedTextBorderWidth = selectedTextBTwidth
	$: if (selectedStoreIcon === 'icon9') selectedTextBorderWidth = selectedTextBBwidth

	const set_icon_color = (c, iNum) => {
		if (c === 'left') {
			if (iNum === 1) icon1Color = iconHover
		}
		if (c === 'top') {
			if (iNum === 2) icon2Color = iconHover
			if (iNum === 6) icon6Color = iconHover
			if (iNum === 8) icon8Color = iconHover
		}
		if (c === 'right') {
			if (iNum === 3) icon3Color = iconHover
		}
		if (c === 'bottom') {
			if (iNum === 4) icon4Color = iconHover
			if (iNum === 7) icon7Color = iconHover
			if (iNum === 9) icon9Color = iconHover
		}
		if (c === 'all') {
			if (iNum === 5) {
				icon1Color = iconHover
				icon2Color = iconHover
				icon3Color = iconHover
				icon4Color = iconHover
				icon5Color = iconHover
			}
		}
		if (c === 'none') {
			if (iNum === 5) {
				icon1Color = iconColor
				icon2Color = iconColor
				icon3Color = iconColor
				icon4Color = iconColor
				icon5Color = iconColor
			}
		}
	}

	const set_fontstyle_initial_value = (c, s, w, d) => {
		if (c === 'title') {
			if (w === 'bold') iconTitleWeight = iconHover
			if (w === 'normal') iconTitleWeight = iconColor
			if (s === 'italic') iconTitleStyle = iconHover
			if (s === 'normal') iconTitleStyle = iconColor
			if (d === 'underline') iconTitleDeco = iconHover
			if (d === 'none') iconTitleDeco = iconColor
		}

		if (c === 'text') {
			if (w === 'bold') iconTextWeight = iconHover
			if (w === 'normal') iconTextWeight = iconColor
			if (s === 'italic') iconTextStyle = iconHover
			if (s === 'normal') iconTextStyle = iconColor
		}
	}

	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'bL') {
					if (icon1 && selectedIcon === 'icon1') {
						block.sliderBLcolor = cssTag
						block.sliderBLwidth = '1'
						icon1Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sliderBLwidth = '0'
						icon1Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bT') {
					if (icon2 && selectedIcon === 'icon2') {
						block.sliderBTcolor = cssTag
						block.sliderBTwidth = '1'
						icon2Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sliderBTwidth = '0'
						icon2Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bR') {
					if (icon3 && selectedIcon === 'icon3') {
						block.sliderBRcolor = cssTag
						block.sliderBRwidth = '1'
						icon3Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sliderBRwidth = '0'
						icon3Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bB') {
					if (icon4 && selectedIcon === 'icon4') {
						block.sliderBBcolor = cssTag
						block.sliderBBwidth = '1'
						icon4Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.sliderBBwidth = '0'
						icon4Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'bA') {
					if (icon5 && selectedIcon === 'icon5') {
						block.sliderBLcolor = cssTag
						block.sliderBLwidth = '1'
						block.sliderBTcolor = cssTag
						block.sliderBTwidth = '1'
						block.sliderBRcolor = cssTag
						block.sliderBRwidth = '1'
						block.sliderBBcolor = cssTag
						block.sliderBBwidth = '1'
						icon5Color = iconHover
						icon1Color = iconHover
						icon2Color = iconHover
						icon3Color = iconHover
						icon4Color = iconHover
					} else {
						block.sliderBLwidth = '0'
						block.sliderBTwidth = '0'
						block.sliderBRwidth = '0'
						block.sliderBBwidth = '0'
						icon5Color = iconColor
						icon1Color = iconColor
						icon2Color = iconColor
						icon3Color = iconColor
						icon4Color = iconColor

						icon1 = false
						icon2 = false
						icon3 = false
						icon4 = false
						icon5 = false
					}
				}

				if (cmd === 'bWidth') {
					if (icon1 && selectedIcon === 'icon1') block.sliderBLwidth = cssTag
					if (icon2 && selectedIcon === 'icon2') block.sliderBTwidth = cssTag
					if (icon3 && selectedIcon === 'icon3') block.sliderBRwidth = cssTag
					if (icon4 && selectedIcon === 'icon4') block.sliderBBwidth = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.sliderBLwidth = cssTag
						block.sliderBTwidth = cssTag
						block.sliderBRwidth = cssTag
						block.sliderBBwidth = cssTag
					}
				}

				if (cmd === 'bColor' || cmd === 'bOpacity') {
					if (icon1 && selectedIcon === 'icon1') block.sliderBLcolor = cssTag
					if (icon2 && selectedIcon === 'icon2') block.sliderBTcolor = cssTag
					if (icon3 && selectedIcon === 'icon3') block.sliderBRcolor = cssTag
					if (icon4 && selectedIcon === 'icon4') block.sliderBBcolor = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.sliderBLcolor = cssTag
						block.sliderBTcolor = cssTag
						block.sliderBRcolor = cssTag
						block.sliderBBcolor = cssTag
					}
				}

				if (cmd === 'btRadius') {
					block.sliderBTradius = cssTag
				}

				if (cmd === 'bbRadius') {
					block.sliderBBradius = cssTag
				}

				if (cmd === 'sliderScolor') {
					block.sliderShadowColor = cssTag
				}

				if (cmd === 'sliderSoffsetX') {
					block.sliderShadowOffsetX = cssTag
				}

				if (cmd === 'sliderSoffsetY') {
					block.sliderShadowOffsetY = cssTag
				}

				if (cmd === 'sliderSblur') {
					block.sliderShadowBlur = cssTag
				}

				if (cmd === 'MBGC') block.modalBackground = cssTag
				if (cmd === 'MCC') block.modalArrows = cssTag
				if (cmd === 'MCCH') block.modalArrowsHover = cssTag
				if (cmd === 'MTFF') block.sliderInsetTitleFont = cssTag
				if (cmd === 'MTFS') block.sliderInsetTitleSize = cssTag
				if (cmd === 'MTFC') block.sliderInsetTitleColor = cssTag
				if (cmd === 'MTFW') block.sliderInsetTitleWeight = block.sliderInsetTitleWeight === 'bold' ? 'normal' : 'bold'
				if (cmd === 'MTSTY')
					block.sliderInsetTitleStyle = block.sliderInsetTitleStyle === 'italic' ? 'normal' : 'italic'

				if (cmd === 'MTDEC')
					block.sliderInsetTitleDeco = block.sliderInsetTitleDeco === 'underline' ? 'none' : 'underline'

				if (cmd === 'MTBG') block.sliderInsetTitleBg = cssTag

				if (cmd === 'MTBT') {
					if (icon6 && selectedIicon === 'icon6') {
						block.sliderInsetTitleBTcolor = cssTag
						block.sliderInsetTitleBTwidth = '1'
						icon6Color = iconHover
					} else {
						block.sliderInsetTitleBTwidth = '0'
						icon6Color = iconColor
					}
				}

				if (cmd === 'MTBB') {
					if (icon7 && selectedIicon === 'icon7') {
						block.sliderInsetTitleBBcolor = cssTag
						block.sliderInsetTitleBBwidth = '1'
						icon7Color = iconHover
					} else {
						block.sliderInsetTitleBBwidth = '0'
						icon7Color = iconColor
					}
				}

				if (cmd === 'MTBTW') {
					if (icon6 && selectedIicon === 'icon6') block.sliderInsetTitleBTwidth = cssTag
					if (icon7 && selectedIicon === 'icon7') block.sliderInsetTitleBBwidth = cssTag
				}

				if (cmd === 'MTBC') {
					if (icon6 && selectedIicon === 'icon6') block.sliderInsetTitleBTcolor = cssTag
					if (icon7 && selectedIicon === 'icon7') block.sliderInsetTitleBBcolor = cssTag
				}

				if (cmd === 'MTBTR') block.sliderInsetTitleBTradius = cssTag
				if (cmd === 'MTBBR') block.sliderInsetTitleBBradius = cssTag
				if (cmd === 'MTSC') block.sliderInsetTitleShadowColor = cssTag
				if (cmd === 'MTTX') block.sliderInsetTitleShadowOffsetX = cssTag
				if (cmd === 'MTTY') block.sliderInsetTitleShadowOffsetY = cssTag
				if (cmd === 'MTTB') block.sliderInsetTitleShadowBlur = cssTag
				if (cmd === 'MTW') block.sliderInsetTitleWidth = cssTag
				if (cmd === 'MTH') block.sliderInsetTitleHeight = cssTag
				if (cmd === 'MTL') block.sliderInsetTitleLeft = cssTag
				if (cmd === 'MTT') block.sliderInsetTitleTop = cssTag

				if (cmd === 'MTXTFF') block.sliderInsetTextFont = cssTag
				if (cmd === 'MTXTFS') block.sliderInsetTextSize = cssTag
				if (cmd === 'MTXTFC') block.sliderInsetTextColor = cssTag
				if (cmd === 'MTXTFW') block.sliderInsetTextWeight = block.sliderInsetTextWeight === 'bold' ? 'normal' : 'bold'
				if (cmd === 'MTXTSTY')
					block.sliderInsetTextStyle = block.sliderInsetTextStyle === 'italic' ? 'normal' : 'italic'

				if (cmd === 'MTXTBG') block.sliderInsetTextBg = cssTag

				if (cmd === 'MTXTBT') {
					if (icon8 && selectedIicon === 'icon8') {
						block.sliderInsetTextBTcolor = cssTag
						block.sliderInsetTextBTwidth = '1'
						icon8Color = iconHover
					} else {
						block.sliderInsetTextBTwidth = '0'
						icon8Color = iconColor
					}
				}

				if (cmd === 'MTXTBB') {
					if (icon9 && selectedIicon === 'icon9') {
						block.sliderInsetTextBBcolor = cssTag
						block.sliderInsetTextBBwidth = '1'
						icon9Color = iconHover
					} else {
						block.sliderInsetTextBBwidth = '0'
						icon9Color = iconColor
					}
				}

				if (cmd === 'MTXTBTW') {
					if (icon8 && selectedIicon === 'icon8') block.sliderInsetTextBTwidth = cssTag
					if (icon9 && selectedIicon === 'icon9') block.sliderInsetTextBBwidth = cssTag
				}

				if (cmd === 'MTXTBC') {
					if (icon8 && selectedIicon === 'icon8') block.sliderInsetTextBTcolor = cssTag
					if (icon9 && selectedIicon === 'icon9') block.sliderInsetTextBBcolor = cssTag
				}

				if (cmd === 'MTXTBTR') block.sliderInsetTextBTradius = cssTag
				if (cmd === 'MTXTBBR') block.sliderInsetTextBBradius = cssTag
				if (cmd === 'MTXTSC') block.sliderInsetTextShadowColor = cssTag
				if (cmd === 'MTXTTX') block.sliderInsetTextShadowOffsetX = cssTag
				if (cmd === 'MTXTTY') block.sliderInsetTextShadowOffsetY = cssTag
				if (cmd === 'MTXTTB') block.sliderInsetTextShadowBlur = cssTag
				if (cmd === 'MTXTW') block.sliderInsetTextWidth = cssTag
				if (cmd === 'MTXTH') block.sliderInsetTextHeight = cssTag
				if (cmd === 'MTXTL') block.sliderInsetTextLeft = cssTag
				if (cmd === 'MTXTT') block.sliderInsetTextTop = cssTag
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_mc_color = (e) => {
		set_css_tag(e.detail.color, 'MCC')
	}

	const set_mch_color = (e) => {
		set_css_tag(e.detail.color, 'MCCH')
	}

	const set_background_color = (e) => {
		set_css_tag(e.detail.color, 'MBGC')
	}
	const set_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_slider_width = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === 'gallery') {
				block.sliderWidth = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_slider_height = (e) => {
		const value = e.detail.value
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.sliderHeight = value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_title_font_color = (e) => {
		set_css_tag(e.detail.color, 'MTFC')
	}

	const set_title_border_color = (e) => {
		set_css_tag(e.detail.color, 'MTBC')
	}

	const set_title_border_width = (e) => {
		set_css_tag(e.detail.value, 'MTBTW')
	}

	const set_title_font_weight = () => {
		set_css_tag(null, 'MTFW')
	}

	const set_title_font_style = () => {
		set_css_tag(null, 'MTSTY')
	}

	const set_title_font_deco = () => {
		set_css_tag(null, 'MTDEC')
	}

	const set_title_height = (e) => {
		set_css_tag(e.detail.value, 'MTH')
	}

	const set_title_font_family = (e) => {
		set_css_tag(e.detail.font, 'MTFF')
	}

	const set_title_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'MTFS')
	}

	const set_text_font_color = (e) => {
		set_css_tag(e.detail.color, 'MTXTFC')
	}

	const set_text_border_color = (e) => {
		set_css_tag(e.detail.color, 'MTXTBC')
	}

	const set_text_border_width = (e) => {
		set_css_tag(e.detail.value, 'MTXTBTW')
	}

	const set_text_font_weight = () => {
		set_css_tag(null, 'MTXTFW')
	}

	const set_text_font_style = () => {
		set_css_tag(null, 'MTXTSTY')
	}

	const set_text_height = (e) => {
		set_css_tag(e.detail.value, 'MTXTH')
	}

	const set_text_font_family = (e) => {
		set_css_tag(e.detail.font, 'MTXTFF')
	}

	const set_icon_1 = () => {
		iconSelected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		if (icon1) icon1Color = iconHover
		else icon1Color = iconColor
		set_css_tag('hsla(0,0%,100%,1)', 'bL')
	}

	const set_icon_2 = () => {
		iconSelected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		if (icon2) icon2Color = iconHover
		else icon2Color = iconColor
		set_css_tag('hsla(0,0%,100%,1)', 'bT')
	}

	const set_icon_3 = () => {
		iconSelected = true
		selectedIcon = 'icon3'
		storeSelectedIcon.set('icon3')
		icon3 = icon3 === false ? true : false
		if (icon3) icon3Color = iconHover
		else icon3Color = iconColor
		set_css_tag('hsla(0,0%,100%,1)', 'bR')
	}

	const set_icon_4 = () => {
		iconSelected = true
		selectedIcon = 'icon4'
		storeSelectedIcon.set('icon4')
		icon4 = icon4 === false ? true : false
		if (icon4) icon4Color = iconHover
		else icon4Color = iconColor
		set_css_tag('hsla(0,0%,100%,1)', 'bB')
	}

	const set_icon_5 = () => {
		iconSelected = true
		selectedIcon = 'icon5'
		storeSelectedIcon.set('icon5')
		icon5 = icon5 === false ? true : false
		if (icon5) icon5Color = iconHover
		else icon5Color = iconColor
		set_css_tag('hsla(0,0%,100%,1)', 'bA')
	}

	const set_icon_6 = () => {
		iconIselected = true
		selectedIicon = 'icon6'
		storeSelectedIcon.set('icon6')
		icon6 = icon6 === false ? true : false
		if (icon6) icon6Color = iconHover
		else icon6Color = iconColor
		set_css_tag('hsla(0,0%,100%,1)', 'MTBT')
	}

	const set_icon_7 = () => {
		iconIselected = true
		selectedIicon = 'icon7'
		storeSelectedIcon.set('icon7')
		icon7 = icon7 === false ? true : false
		if (icon7) icon7Color = iconHover
		else icon7Color = iconColor
		set_css_tag('hsla(0,0%,100%,1)', 'MTBB')
	}

	const set_icon_8 = () => {
		iconIselected = true
		selectedIicon = 'icon8'
		storeSelectedIcon.set('icon8')
		icon8 = icon8 === false ? true : false
		if (icon8) icon8Color = iconHover
		else icon8Color = iconColor
		set_css_tag('hsla(0,0%,100%,1)', 'MTXTBT')
	}

	const set_icon_9 = () => {
		iconIselected = true
		selectedIicon = 'icon9'
		storeSelectedIcon.set('icon9')
		icon9 = icon9 === false ? true : false
		if (icon9) icon9Color = iconHover
		else icon9Color = iconColor
		set_css_tag('hsla(0,0%,100%,1)', 'MTXTBB')
	}

	let toTool
	const open_tool = (t) => {
		switch (t) {
			case 'generalTool1':
				generalTool1 = generalTool1 === false ? true : false
				showTool4 = false
				showTool6 = false
				showTool7 = false
				break

			case 'generalTool2':
				generalTool2 = generalTool2 === false ? true : false
				showTool8 = false
				showTool10 = false
				break

			case 0:
				showTool0 = showTool0 === true ? false : true
				showTool1 = false
				showTool3 = false
				showTool7 = false
				showTool11 = false
				break

			case 1:
				showTool1 = showTool1 === true ? false : true
				showTool0 = false
				showTool3 = false
				showTool7 = false
				showTool11 = false
				if (showTool1) {
					if (!icon1) icon1Color = iconColor
					if (!icon2) icon2Color = iconColor
					if (!icon3) icon3Color = iconColor
					if (!icon4) icon4Color = iconColor
					if (!icon1 || !icon2 || !icon3 || !icon4) icon5Color = iconColor

					toTool = setTimeout(() => {
						icon1Color = icon1Color
						icon2Color = icon2Color
						icon3Color = icon3Color
						icon4Color = icon4Color
						icon5Color = icon5Color
					}, 10)
				}
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				showTool1 = false
				showTool0 = false
				showTool7 = false
				showTool11 = false
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				generalTool1 = false
				showTool6 = false
				showTool7 = false
				if (showTool4) {
					if (!icon6) icon6Color = iconColor
					if (!icon7) icon7Color = iconColor

					toTool = setTimeout(() => {
						icon6Color = icon6Color
						icon7Color = icon7Color
					}, 10)
				}
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				break

			case 6:
				showTool6 = showTool6 === true ? false : true
				generalTool1 = false
				showTool4 = false
				showTool7 = false
				break

			case 7:
				showTool7 = showTool7 === true ? false : true
				showTool1 = false
				showTool3 = false
				showTool0 = false
				showTool11 = false
				break

			case 8:
				showTool8 = showTool8 === true ? false : true
				generalTool2 = false
				showTool10 = false
				if (showTool8) {
					if (!icon8) icon8Color = iconColor
					if (!icon9) icon9Color = iconColor

					toTool = setTimeout(() => {
						icon8Color = icon8Color
						icon9Color = icon9Color
					}, 10)
				}
				break

			case 9:
				showTool9 = showTool9 === true ? false : true
				break

			case 10:
				showTool10 = showTool10 === true ? false : true
				generalTool2 = false
				showTool8 = false
				break

			case 11:
				showTool11 = showTool11 === true ? false : true
				showTool7 = false
				showTool1 = false
				showTool3 = false
				showTool0 = false
				break
		}
	}

	const close_modal = () => {
		storeShowGallery.set(false)
		storeSelectedTool.set('--')
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
		stoAnimate
		clearTimeout(toTool)
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<div
			class="part_title mainTool"
			on:click={() => open_tool(0)}
			on:keydown={() => open_tool(0)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			MAIN CONTAINER
		</div>
		{#if showTool0}
			<div transition:slide={{ duration: 500 }}>
				<div class="sub_title_small" use:styles={{ fsXS }}>Background Color</div>
				<ColorSelector
					on:setcolor={set_background_color}
					on:setopacity={set_background_color}
					ID={idColor6}
					showTranparency={true}
					selectedColor={selectedBackgroundColor}
					initialValue={selectedBgOpac}
				/>
				<div class="sub_title_small" use:styles={{ fsXS }}>Width</div>
				<SizeSelector
					ID={idSliderWidth}
					initialValue={selectedSliderWidth}
					range="70"
					unit="%"
					on:sizechange={set_slider_width}
				/>

				<div class="sub_title_small" use:styles={{ fsXS }}>Height</div>
				<SizeSelector
					ID={idSliderHeight}
					initialValue={selectedSliderHeight}
					range="45"
					unit="%"
					on:sizechange={set_slider_height}
				/>
			</div>
		{/if}

		<div
			class="part_title mainTool"
			on:click={() => open_tool(11)}
			on:keydown={() => open_tool(11)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			CONTROLS
		</div>

		{#if showTool11}
			<div transition:slide={{ duration: 500 }}>
				<ColorSelector on:setcolor={set_mc_color} ID={idColor7} showTranparency={false} selectedColor={selectedMC} />

				<ColorSelector
					on:setcolor={set_mch_color}
					ID={idColor8}
					showTranparency={false}
					selectedColor={selectedMChover}
				/>
			</div>
		{/if}

		<div
			class="part_title mainTool"
			on:click={() => open_tool(1)}
			on:keydown={() => open_tool(1)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			IMAGE BORDER
		</div>
		{#if showTool1}
			<div transition:slide={{ duration: 500 }}>
				<div class="icon_container">
					<div
						id="icon1"
						class="icon icon1"
						use:styles={{ icon, icon1Color, iconHover }}
						on:click={set_icon_1}
						on:keydown={set_icon_1}
					/>
					<div
						id="icon2"
						class="icon icon2"
						use:styles={{ icon, icon2Color, iconHover }}
						on:click={set_icon_2}
						on:keydown={set_icon_2}
					/>
					<div
						id="icon3"
						class="icon icon3"
						use:styles={{ icon, icon3Color, iconHover }}
						on:click={set_icon_3}
						on:keydown={set_icon_3}
					/>
					<div
						id="icon4"
						class="icon icon4"
						use:styles={{ icon, icon4Color, iconHover }}
						on:click={set_icon_4}
						on:keydown={set_icon_4}
					/>
					<div
						id="icon5"
						class="icon icon5"
						use:styles={{ icon, icon5Color, iconHover }}
						on:click={set_icon_5}
						on:keydown={set_icon_4}
					/>
				</div>
				{#if iconSelected}
					<div in:slide={{ duration: 500 }}>
						<div class="sub_title_small" use:styles={{ fsXS }}>Border Color</div>
						<ColorSelector
							on:setcolor={set_border_color}
							ID={idColor1}
							showTranparency={false}
							selectedColor={selectedBorderColor}
						/>

						<div class="sub_title_small" use:styles={{ fsXS }}>Border Width</div>
						<SizeSelector
							ID={idBorderWidth}
							range="50"
							unit="px"
							initialValue={selectedBorderWidth}
							on:sizechange={set_border_width}
						/>
					</div>
				{/if}
			</div>
		{/if}

		<div
			class="part_title mainTool"
			on:click={() => open_tool(3)}
			on:keydown={() => open_tool(3)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			TITLE CONTAINER
		</div>
		{#if showTool3}
			<div transition:slide={{ duration: 500 }}>
				<div
					class="part_title subTool"
					on:click={() => open_tool('generalTool1')}
					on:keydown={() => open_tool('generalTool1')}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					general
				</div>
				{#if generalTool1}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title_small" use:styles={{ fsXS }}>height</div>
						<SizeSelector
							ID={idTitleHeight}
							initialValue={selectedMTitleHeight}
							unit="px"
							range="100"
							on:sizechange={set_title_height}
						/>
					</div>
				{/if}
			</div>

			<div
				class="part_title subTool"
				on:click={() => open_tool(4)}
				on:keydown={() => open_tool(4)}
				use:styles={{ subTool, subToolHover, fsXS }}
			>
				border
			</div>
			{#if showTool4}
				<div transition:slide={{ duration: 500 }}>
					<div class="icon_container">
						<div
							id="icon6"
							class="icon icon6"
							use:styles={{ icon, icon6Color, iconHover }}
							on:click={set_icon_6}
							on:keydown={set_icon_6}
						/>

						<div
							id="icon7"
							class="icon icon7"
							use:styles={{ icon, icon7Color, iconHover }}
							on:click={set_icon_7}
							on:keydown={set_icon_7}
						/>
					</div>
					{#if iconIselected}
						<div in:slide={{ duration: 500 }}>
							<div class="sub_title_small" use:styles={{ fsXS }}>Border Color</div>
							<ColorSelector
								on:setcolor={set_title_border_color}
								ID={idColor2}
								showTranparency={false}
								selectedColor={selectedTitleBorderColor}
							/>

							<div class="sub_title_small" use:styles={{ fsXS }}>Border Width</div>
							<SizeSelector
								ID={idTitleBW}
								range="20"
								unit="px"
								initialValue={selectedTitleBorderWidth}
								on:sizechange={set_title_border_width}
							/>
						</div>
					{/if}
				</div>
			{/if}

			<div
				class="part_title subTool"
				on:click={() => open_tool(6)}
				on:keydown={() => open_tool(6)}
				use:styles={{ subTool, subToolHover, fsXS }}
			>
				font
			</div>
			{#if showTool6}
				<div transition:slide={{ duration: 500 }}>
					<div class="sub_title_small" use:styles={{ fsXS }}>Font Color</div>
					<ColorSelector
						on:setcolor={set_title_font_color}
						on:setopacity={set_title_font_color}
						ID={idColor4}
						selectedColor={selectedTitleFontColor}
						initialValue={selectedTitleFontOpac}
					/>
					<div class="sub_title_small" use:styles={{ fsXS }}>Font Family</div>
					<SelectValues
						options={fontFamily}
						on:select={set_title_font_family}
						value={selectedTitleFont}
						ID={idSelect1}
					/>
					<div class="sub_title_small" use:styles={{ fsXS }}>Font Size</div>
					<SelectValues options={fontSize} on:select={set_title_font_size} value={selectedTitleSize} ID={idSelect2} />
					<div class="sub_title_small" use:styles={{ fsXS }}>Font Decoration</div>
					<div class="icon_container">
						<div
							id="fweight"
							class="icon iconTitleWeight"
							use:styles={{ icon, iconTitleWeight, iconHover }}
							on:click={set_title_font_weight}
							on:keydown={set_title_font_weight}
						/>
						<div
							id="fstyle"
							class="icon iconTitleStyle"
							use:styles={{ icon, iconTitleStyle, iconHover }}
							on:click={set_title_font_style}
							on:keydown={set_title_font_style}
						/>

						<div
							id="fdeco"
							class="icon iconTitleDeco"
							use:styles={{ icon, iconTitleDeco, iconHover }}
							on:click={set_title_font_deco}
							on:keydown={set_title_font_deco}
						/>
						<div />
						<div />
					</div>
				</div>
			{/if}
		{/if}

		<div
			class="part_title mainTool"
			on:click={() => open_tool(7)}
			on:keydown={() => open_tool(7)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			TEXT CONTAINER
		</div>
		{#if showTool7}
			<div transition:slide={{ duration: 500 }}>
				<div
					class="part_title subTool"
					on:click={() => open_tool('generalTool2')}
					on:keydown={() => open_tool('generalTool2')}
					use:styles={{ subTool, subToolHover, fsXS }}
				>
					general
				</div>
				{#if generalTool2}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title_small" use:styles={{ fsXS }}>height</div>
						<SizeSelector
							ID={idTextHeight}
							initialValue={selectedMTextHeight}
							unit="px"
							range="200"
							on:sizechange={set_text_height}
						/>
					</div>
				{/if}
			</div>
			<div
				class="part_title subTool"
				on:click={() => open_tool(8)}
				on:keydown={() => open_tool(8)}
				use:styles={{ subTool, subToolHover, fsXS }}
			>
				border
			</div>
			{#if showTool8}
				<div transition:slide={{ duration: 500 }}>
					<div class="icon_container">
						<div
							id="icon8"
							class="icon icon8"
							use:styles={{ icon, icon8Color, iconHover }}
							on:click={set_icon_8}
							on:keydown={set_icon_8}
						/>

						<div
							id="icon9"
							class="icon icon9"
							use:styles={{ icon, icon9Color, iconHover }}
							on:click={set_icon_9}
							on:keydown={set_icon_9}
						/>
					</div>
					{#if iconIselected}
						<div in:slide={{ duration: 500 }}>
							<div class="sub_title_small" use:styles={{ fsXS }}>Border Color</div>
							<ColorSelector
								on:setcolor={set_text_border_color}
								ID={idColor3}
								showTranparency={false}
								selectedColor={selectedTextBorderColor}
							/>

							<div class="sub_title_small" use:styles={{ fsXS }}>Border Width</div>
							<SizeSelector
								ID={idTextBW}
								range="20"
								unit="px"
								initialValue={selectedTextBorderWidth}
								on:sizechange={set_text_border_width}
							/>
						</div>
					{/if}
				</div>
			{/if}

			<div
				class="part_title subTool"
				on:click={() => open_tool(10)}
				on:keydown={() => open_tool(10)}
				use:styles={{ subTool, subToolHover, fsXS }}
			>
				font
			</div>
			{#if showTool10}
				<div transition:slide={{ duration: 500 }}>
					<div class="sub_title_small" use:styles={{ fsXS }}>Font Color</div>
					<ColorSelector
						on:setcolor={set_text_font_color}
						on:setopacity={set_text_font_color}
						ID={idColor5}
						selectedColor={selectedTextFontColor}
						initialValue={selectedTextFontOpac}
					/>
					<div class="sub_title_small" use:styles={{ fsXS }}>Font Family</div>
					<SelectValues options={fontFamily} on:select={set_text_font_family} value={selectedTextFont} ID={idSelect1} />
					<!-- <div class="sub_title_small" use:styles={{ fsXS }}>Font Size</div>
			<SelectValues options={fontSize} on:select={set_text_font_size} value={selectedTextSize} ID={idSelect2} /> -->
					<div class="sub_title_small" use:styles={{ fsXS }}>Font Decoration</div>
					<div class="icon_container">
						<div
							id="fweight"
							class="icon iconTextWeight"
							use:styles={{ icon, iconTextWeight, iconHover }}
							on:click={set_text_font_weight}
							on:keydown={set_text_font_weight}
						/>
						<div
							id="fstyle"
							class="icon iconTextStyle"
							use:styles={{ icon, iconTextStyle, iconHover }}
							on:click={set_text_font_style}
							on:keydown={set_text_font_style}
						/>
						<div />
						<div />
					</div>
				</div>
			{/if}
		{/if}

		<div class="close_button" use:styles={{ fsS }} on:click={close_modal} on:keydown={close_modal}>CLOSE GALLERY</div>
	</main>
{/if}

{#if shaderChangeOrder}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="change block order" />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	.close_button {
		display: flex;
		width: 100%;
		justify-content: center;
		background-color: hsl(243, 96%, 52%);
		font-size: var(--fsS);
		color: white;
		margin-top: 20px;
		margin-bottom: 20px;
		padding: 10px;
		cursor: pointer;
	}

	.close_button:hover {
		background-color: hsl(243, 96%, 72%);
		color: black;
	}

	.sub_title_small {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		font-size: var(--fsS);
		padding: 10px;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title_small {
		font-size: var(--fsXS);
		padding: 5px 0px 0px 10px;
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.icon1 {
		background-color: var(--icon1Color);
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon2,
	.icon6,
	.icon8 {
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
	}
	.icon6 {
		background-color: var(--icon6Color);
	}
	.icon8 {
		background-color: var(--icon8Color);
	}

	.icon3 {
		background-color: var(--icon3Color);
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon4,
	.icon7,
	.icon9 {
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--icon4Color);
	}
	.icon7 {
		background-color: var(--icon7Color);
	}
	.icon9 {
		background-color: var(--icon9Color);
	}

	.icon5 {
		background-color: var(--icon5Color);
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.iconTitleWeight {
		background-color: var(--iconTitleWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconTitleStyle {
		background-color: var(--iconTitleStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.iconTitleDeco {
		background-color: var(--iconTitleDeco);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.iconTextWeight {
		background-color: var(--iconTextWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconTextStyle {
		background-color: var(--iconTextStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
